/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import Icon from 'material/graphic/icon/icon';
import List from 'material/list/list';
// styles
import injectSheet from 'react-jss';
import styles from 'material/sortablelist/sortableitem/sortableitem_styles';


/* ========== ~~~~~~~~~~ SORTABLE : ITEM : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const SortableItem = (props) => {

	const { item, selected, disabled, handleSelect } = props;

	return (
		<span className={`sortableitem ${props.classes.sortableitem}`}>
			<div className='drag-icon'>
				<Icon color={'supporting'} name={'grip-vertical'} style={'fas fa-2x'} />
			</div>
			<div className='single-item-list'>
				<List
					type='checkbox'
					items={item}
					selected={selected}
					disabled={disabled}
					handleChange={handleSelect} />
			</div>
		</span>
	);
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SortableItem);